<template>
  <div>
    <el-checkbox v-model="showConnectorVal">显示连接符</el-checkbox>
    <div class="block-setting mt8" v-if="showConnectorVal">
      <color-set
        class="custom-text-bg flex-box"
        :config.sync="connectorColorVal"
      />
      <slider-and-input class="mt8" :value.sync="connectorWidthVal" title="粗细" :sliderMax="100" suffix="px"/>
    </div>
  </div>
</template>
<script>
import cxColorPicker from "./cxColorPicker.vue"
import complexSetMixin from "./complexSetMixin.js"
export default {
  components: {
    colorSet: cxColorPicker,
  },
  mixins: [complexSetMixin()],
  props: {
    connectorColor: [Object,Array],
    connectorWidth: [String,Number],
    showConnector: Boolean
  },
  computed: {
    connectorColorVal: {
      get() {
        if(this.defaultValue){
          return  this.configData.connectorColor
        }
        return this.connectorColor
      },
      set(newVal) {
        if(this.defaultValue){
          this.configData.connectorColor = newVal
        }else{
          this.$emit('update:connectorColor', newVal)
        }
        this.changeConnectorStyle()
      }
    },
    connectorWidthVal: {
      get() {
        if(this.defaultValue){
          return  this.configData.connectorWidth
        }
        return this.connectorWidth
      },
      set(newVal) {
        if(this.defaultValue){
          this.configData.connectorWidth = newVal
        }else{
          this.$emit('update:connectorWidth', newVal)
        }
        this.changeConnectorStyle()
      }
    },
    showConnectorVal: {
      get() {
        if(this.defaultValue){
          return  this.configData.showConnector
        }
        return this.showConnector
      },
      set(newVal) {
        if(this.defaultValue){
          this.configData.showConnector = newVal
        }else{
          this.$emit('update:showConnector', newVal)
        }
        this.changeConnectorStyle()
      }
    }
  },
  methods:{
    changeConnectorStyle(){
      this.$eventBus.$emit("updateConnectorStyle")
    }
  }
}
</script>